<template>
  <div
    class="rounded-3xl border border-white/10 bg-white/10 p-6 shadow-lg transition duration-200 hover:-translate-y-1 hover:border-rtcblue-400/40"
  >
    <div class="mb-5 flex items-center justify-between">
      <div
        class="flex h-10 w-10 items-center justify-center rounded-full font-black"
        :class="statusClasses"
      >
        {{ statusIcon }}
      </div>

      <span
        class="rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide"
        :class="badgeClasses"
      >
        {{ statusLabel }}
      </span>
    </div>

    <h3 class="text-xl font-black text-white">
      {{ title }}
    </h3>

    <p class="mt-3 text-sm leading-6 text-slate-300">
      {{ description }}
    </p>

    <div class="mt-6">
      <div class="mb-2 flex justify-between text-sm font-semibold">
        <span class="text-slate-400">{{ $t("home.readiness") }}</span>
        <span class="text-white">{{ readiness }}%</span>
      </div>

      <div class="h-2 rounded-full bg-white/10">
        <div
          class="h-2 rounded-full bg-rtcblue-500"
          :style="{ width: readiness + '%' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StageCard",

  props: {
    title: String,
    description: String,
    status: String,
    readiness: Number,
  },

  computed: {
    statusLabel() {
      const map = {
        complete: "home.statusComplete",
        active: "home.statusActive",
        planned: "home.statusPlanned",
      };
      return this.$t(map[this.status] || "home.statusPlanned");
    },

    statusIcon() {
      if (this.status === "complete") {
        return "✓";
      }

      if (this.status === "active") {
        return "→";
      }

      return "•";
    },

    statusClasses() {
      if (this.status === "complete") {
        return "bg-rtcblue-100 text-rtcblue-700";
      }

      if (this.status === "active") {
        return "bg-sky-100 text-sky-700";
      }

      return "bg-slate-100 text-slate-400";
    },

    badgeClasses() {
      if (this.status === "complete") {
        return "bg-rtcblue-100 text-rtcblue-700";
      }

      if (this.status === "active") {
        return "bg-sky-100 text-sky-700";
      }

      return "bg-slate-100 text-slate-400";
    },
  },
};
</script>
